class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
        setTimeout(() => {
          document.body.addEventListener('click', this.onBodyClick);
        }, 10);
      },
      { once: true }
    );
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  async renderContents(img, title) {
    const container = this.querySelector('.cart-notification-product');
    if (!container) {
      throw new Error('Product container not found');
    }
    container.innerHTML = '';
    container.appendChild(img.cloneNode(true));
    container.appendChild(title.cloneNode(true));
    // container.appendChild(product.querySelector('.product-card-img img').cloneNode(true));
    // container.appendChild(product.querySelector('.product-card-title').cloneNode(true));
    this.open();
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const cartTotalEl = document.querySelector('.icon-cart strong');
      if (cartTotalEl) {
        const currencySymbol = cartTotalEl.textContent.substring(0, 1);
        const newPrice = (cart.total_price / 100).toFixed(2);
        cartTotalEl.textContent = `${currencySymbol} ${newPrice}`;
      }
    } catch (e) {
      console.error('Failed to update cart total:', e);
    }
  }
  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
